import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";

import { withRouter } from "react-router-dom";
import {
  changeLayout,
  changeLayoutMode,
  changeLayoutWidth,
  changeSidebarSize,
  changeSidebarTheme,
  changeTopbarTheme,
  showRightSidebarAction,
} from "../../store/actions";

import Footer from '../Common/Footer';
import Header from "./Header";
import Sidebar from "./Sidebar";

//redux
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const Layout = (props) => {
  const dispatch = useDispatch();

  const {
    isPreloader,
    layoutWidth,
    layoutModeType,
    leftSideBarType,
    topbarTheme,
    sidebarSizeType,
    leftSideBarTheme,
  } = useSelector((state) => ({
    isPreloader: state.Layout.isPreloader,
    leftSideBarType: state.Layout.leftSideBarType,
    layoutModeType: state.Layout.layoutModeType,
    layoutWidth: state.Layout.layoutWidth,
    topbarTheme: state.Layout.topbarTheme,
    sidebarSizeType: state.Layout.sidebarSizeType,
    leftSideBarTheme: state.Layout.leftSideBarTheme,
  }), shallowEqual);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarSize("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarSize("default", isMobile));
    }
  };

  //hides right sidebar on body click
  const hideRightbar = useCallback((event) => {
    var rightbar = document.getElementById("right-bar");
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return;
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false));
    }
  }, [dispatch]);
  /*
  layout  settings
  */

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);

    if (isPreloader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  }, [isPreloader, hideRightbar]);

  // 1. Global scroll & click tracker: records scroll position for each route in real time
  useEffect(() => {
    const handleScrollOrClick = () => {
      const currentPath = window.location.pathname;
      const currentScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (currentScrollY > 10) {
        sessionStorage.setItem(`last_scroll_pos_${currentPath}`, currentScrollY.toString());
      }
    };

    window.addEventListener('scroll', handleScrollOrClick, { passive: true });
    document.addEventListener('click', handleScrollOrClick, true);

    return () => {
      window.removeEventListener('scroll', handleScrollOrClick);
      document.removeEventListener('click', handleScrollOrClick, true);
    };
  }, []);

  // 2. Global route change listener: restores scroll when navigating back on ANY screen
  useEffect(() => {
    const currentPath = props.location.pathname;
    const isNavigatingBack = sessionStorage.getItem('is_navigating_back') === 'true';
    const savedScrollYStr = sessionStorage.getItem(`last_scroll_pos_${currentPath}`);

    if (isNavigatingBack && savedScrollYStr) {
      const targetY = parseInt(savedScrollYStr, 10);
      if (targetY > 10) {
        let attempts = 0;
        const interval = setInterval(() => {
          attempts++;

          window.scrollTo(0, targetY);
          if (document.documentElement) document.documentElement.scrollTop = targetY;
          if (document.body) document.body.scrollTop = targetY;

          const currentY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;

          // If reached target position within 50px tolerance or after 40 attempts (4.0s)
          if (Math.abs(currentY - targetY) < 50 || attempts > 40) {
            clearInterval(interval);
            sessionStorage.removeItem('is_navigating_back');
            sessionStorage.removeItem(`last_scroll_pos_${currentPath}`);
          }
        }, 100);

        return () => clearInterval(interval);
      } else {
        sessionStorage.removeItem('is_navigating_back');
      }
    } else if (!isNavigatingBack) {
      window.scrollTo(0, 0);
    }
  }, [props.location.pathname]);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);
  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (sidebarSizeType) {
      dispatch(changeSidebarSize(sidebarSizeType));
    }
  }, [sidebarSizeType, dispatch]);

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);

  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <i className="uil-shutter-alt spin-icon"></i>
          </div>
        </div>
      </div>
      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar
          theme={leftSideBarTheme}
          isMobile={isMobile}
        />
        <div className="main-content">{props.children}</div>
        <Footer props='160px' />
      </div>
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeLayoutMode: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarSize: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutModeType: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default withRouter(Layout);
